import { render, staticRenderFns } from "./publishTask.vue?vue&type=template&id=9b8be8ec&scoped=true&"
import script from "./publishTask.vue?vue&type=script&lang=js&"
export * from "./publishTask.vue?vue&type=script&lang=js&"
import style0 from "./publishTask.vue?vue&type=style&index=0&id=9b8be8ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8be8ec",
  null
  
)

export default component.exports